import React from "react";
import TravelCustomCssPreview from "./TravelCustomCssPreview";
import TravellerProfileForm from "src/pages/travel/tile-content/TravellerProfileForm";
import { useNavigate, useLocation } from "react-router-dom";

const TravelEmbed = ({ content, onPageClick }) => {
  const { custom_html, travel_pages = [] } = content || {};
  const navigate = useNavigate();
  const location = useLocation();

  const params = new URLSearchParams(location.search);
  const pageParam = params.get("page");

  const travelPagesRef = React.useRef([]);
  if (travel_pages && travel_pages.length > 0) {
    travelPagesRef.current = travel_pages;
  }

  const activePageData = travelPagesRef.current.find((p) => (p?.slug || p?._id) === pageParam);
  const isProfile = activePageData?.embed_type === "TRAVEL_PROFILE" || content?.embed_type === "TRAVEL_PROFILE";

  const handlePageClick = (slug) => {
    const params = new URLSearchParams(location.search);
    params.set("page", slug);
    params.set("from", "travel");
    navigate({ search: `?${params.toString()}` }, { replace: true });
    onPageClick?.(slug);
  };

  if (isProfile) {
    return (
      <TravellerProfileForm
        page={pageParam}
        onBack={() => {
          const params = new URLSearchParams(location.search);
          const defaultPage = travelPagesRef.current.find((p) => p.embed_type !== "TRAVEL_PROFILE");
          if (defaultPage) {
            params.set("page", defaultPage.slug || defaultPage._id);
          } else {
            params.delete("page");
            params.delete("from");
          }
          navigate({ search: params.toString() ? `?${params.toString()}` : "" }, { replace: true });
        }}
      />
    );
  }

  if (!custom_html) {
    return <div className="rounded-md border border-dashed bg-gray-50 py-10 text-center text-sm text-gray-400">No HTML configured for this travel page.</div>;
  }

  return (
    <div className="relative h-full w-full">
      <TravelCustomCssPreview
        template={custom_html}
        pages={travel_pages}
        onPageClick={handlePageClick}
        autoResize={true}
        bannerImage={content?.travel_home_banner_image || "https://open-domo-portals.s3.us-west-2.amazonaws.com/form_file-2f036911hmquzauxe-0"}
        footerImage={content?.travel_home_footer_image || "https://open-domo-portals.s3.us-west-2.amazonaws.com/form_file-2f036911hmquzauxe-0"}
      />
    </div>
  );
};

export default TravelEmbed;
